import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import store from "./../store";
import { DetectBrand } from "../mixins/brandDetector";
var brandedConfig = {
  apiKey: "AIzaSyCGhJa8iZM_JU3UvEQ37gz5qOrQbwOdcEQ",
  authDomain: "abacus-online-ordering-test.firebaseapp.com",
  databaseURL: "https://abacus-online-ordering-test.firebaseio.com",
  projectId: "abacus-online-ordering-test",
  storageBucket: "abacus-online-ordering-test.appspot.com",
  messagingSenderId: "1087170880950"
};
var generalConfig = {
  apiKey: "AIzaSyAMhuFsddO482nDpQp-jr6tUwyw-mjG6Us",
  authDomain: "abacus-company-project.firebaseapp.com",
  databaseURL: "https://abacus-company-project.firebaseio.com",
  projectId: "abacus-company-project",
  storageBucket: "abacus-company-project.appspot.com",
  messagingSenderId: "799769146157",
  appId: "1:799769146157:web:d497b21a3e793a5c"
};
var releaseConfig = {
  apiKey: "AIzaSyD9SaN0tNal4v0_hT46IJpWiq8XyRqax8w",
  authDomain: "abacusoo-small-bar.firebaseapp.com",
  databaseURL: "abacusoo-small-bar.firebaseio.com",
  projectId: "abacusoo-small-bar",
  storageBucket: "abacusoo-small-bar.appspot.com",
  messagingSenderId: "124323662326"
};
firebase.initializeApp(
  process.env.NODE_ENV === "production"
    ? releaseConfig
    : DetectBrand.methods.isBranded()
    ? brandedConfig
    : generalConfig
);

/*
  setLogLevel param:
- debug for the most verbose logging level, primarily for debugging.
- error to log errors only.
- silent to turn off logging.
*/
firebase.firestore.setLogLevel("silent");

export const db = firebase.firestore();
export const auth = firebase.auth();
auth.onAuthStateChanged(user => {
  if (user) {
    store.dispatch("autoSignIn", user);
  }
});
